import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import { InputFormField, SelectFormField } from "@components/FormField/HookFormFields";
import { FullWidthInputWrapper } from "@components";
import { selectAvailableCountryOptions } from "@redux";

export const ClientFundRecCountry = ({ control, countryIndex }) => {
  const availableCountries = useSelector(selectAvailableCountryOptions);
  return (
    <>
      {/* neccessary for form value */}
      <InputFormField
        control={control}
        name={`clientFundsRecCountrys.${countryIndex}.clientFundsRecCountryType`}
        defaultValue={countryIndex === 0 ? "S.121" : `CFURC${countryIndex + 1}`}
        className="d-none"
      />

      <FullWidthInputWrapper>
        <SelectFormField
          control={control}
          name={`clientFundsRecCountrys.${countryIndex}.data.clientFundsRecCountry`}
          title={trb(i18.Labels.ClientFundsRecCountry)}
          options={availableCountries}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
          defaultValue="LT"
        />
      </FullWidthInputWrapper>
    </>
  );
};
